import type { ProductGroupView } from '@/types';

import { sendGAEvent } from '@next/third-parties/google';

const googleEventViewItem = (product: ProductGroupView): any => {
  sendGAEvent('event', 'view_item', {
    currency: 'IRR',
    value: product.pricing?.payable_price || product.price,
    items: [
      {
        itemId: product.id,
        item_name: product.title,
        currency: 'IRR',
        price: product.pricing?.payable_price || product.price,
        discount: product.pricing?.discount_price || 0,
      },
    ],
  });
};
export default googleEventViewItem;
